import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const US_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

const StateLicenseInput = ({ selectedStates, setSelectedStates }) => {
  const [inputValue, setInputValue] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);

  useEffect(() => {
    setIsAllSelected(selectedStates.length === US_STATES.length);
  }, [selectedStates]);
  useEffect(() => {
    if (selectedStates.length >= 1) {
      setInputValue(selectedStates.join(", "));
    }
  }, []);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setSelectedStates(
      e.target.value
        .split(",")
        .map((state) => state.trim())
        .filter((state) => US_STATES.includes(state))
    );
  };

  const handleStateToggle = (state) => {
    setSelectedStates((prev) =>
      prev.includes(state) ? prev.filter((s) => s !== state) : [...prev, state]
    );
  };

  const handleSelectAll = () => {
    setSelectedStates(isAllSelected ? [] : [...US_STATES]);
  };

  const handleSave = () => {
    setInputValue(selectedStates.join(", "));
    setIsDrawerOpen(false);
  };

  return (
    <div className="max-w-md mx-auto py-4">
      <label
        htmlFor="state-input"
        className="font-semibold uppercase text-[12px] text-gray-600"
      >
        Enter states you're licensed in (comma-separated)
        <span className="text-red-500">*</span>
      </label>
      <input
        id="state-input"
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm"
        placeholder="E.g. California, New York, Texas"
      />
      <div className="mt-2 flex justify-between items-center">
        <span className="text-xs text-gray-500">
          States Selected: {selectedStates.length}
        </span>
        <button
          onClick={() => setIsDrawerOpen(true)}
          className="text-gray-600 hover:text-gray-800 underline text-xs focus:outline-none"
          type="button"
        >
          Select Multiple States
        </button>
      </div>

      {isDrawerOpen && (
        <div className="fixed inset-0 overflow-hidden z-50">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              onClick={() => setIsDrawerOpen(false)}
            />
            <section className="absolute inset-y-0 right-0 pl-10 max-w-full flex">
              <div className="relative w-screen max-w-md">
                <div className="h-full flex flex-col py-6 bg-white shadow-xl overflow-y-scroll pb-16">
                  <div className="px-4 sm:px-6">
                    <div className="flex items-start justify-between">
                      <h2 className="text-lg font-medium text-gray-900">
                        Select States
                      </h2>
                      <button
                        onClick={() => setIsDrawerOpen(false)}
                        className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <span className="sr-only">Close panel</span>
                        <X className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                  <div className="mt-6 relative flex-1 px-4 sm:px-6">
                    <div className="space-y-2">
                      <label className="flex items-center font-medium">
                        <input
                          type="checkbox"
                          checked={isAllSelected}
                          onChange={handleSelectAll}
                          className="h-4 w-4 text-primary focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <span className="ml-2 text-gray-700 text-sm">
                          Select All
                        </span>
                      </label>
                      <hr className="my-4" />
                      {US_STATES.map((state) => (
                        <label key={state} className="flex items-center">
                          <input
                            type="checkbox"
                            checked={selectedStates.includes(state)}
                            onChange={() => handleStateToggle(state)}
                            className="h-4 w-4 text-primary focus:ring-blue-500 border-gray-300 rounded"
                          />
                          <span className="ml-2 text-gray-700 text-sm">
                            {state}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="mt-6 px-4 sm:px-6 absolute bottom-0 left-0 right-0 bg-white py-3">
                  <button
                    onClick={handleSave}
                    className="w-full px-4 py-2 bg-primary text-white rounded-md hover:bg-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                  >
                    Save Selection
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
    </div>
  );
};

export default StateLicenseInput;
